export type Runtime = 'browser' | 'node' | 'deno' | 'unknown';

/* eslint-disable @typescript-eslint/no-explicit-any */
const g = globalThis as any;

export function detectRuntime(): Runtime {
  if (typeof g.process?.versions?.node === 'string') {
    return 'node';
  }

  if (typeof g.Deno !== 'undefined') {
    return 'deno';
  }

  if (typeof g.window !== 'undefined' || typeof g.self !== 'undefined') {
    return 'browser';
  }

  return 'unknown';
}

/**
 * True only on a browser's *main* thread.
 *
 * The Wasm core is built with pthreads, and Emscripten's pthread pool makes
 * the calling thread block on `Atomics.wait`, which is disallowed on the main
 * thread. A browser context that is itself inside a Worker is fine, and
 * returns false.
 */
export function isBrowserMainThread(): boolean {
  return detectRuntime() === 'browser' && typeof g.WorkerGlobalScope === 'undefined';
}
